import { Button } from '@mantine/core';
import { FaTrash } from 'react-icons/fa';

interface DeleteRecordButtonProps {
  disabled?: boolean;
  count?: number;
  onClick: () => void;
}

export const DeleteRecordButton = ({ disabled = false, count = 0, onClick }: DeleteRecordButtonProps) => {
  const buttonText = count > 0 ? `Delete (${count})` : 'Delete';
  
  return (
    <Button
      variant="outline"
      color="red"
      leftSection={<FaTrash size={16} />}
      disabled={disabled || count === 0}
      onClick={onClick}
    >
      {buttonText}
    </Button>
  );
};